import { clientEnv } from '@/config/env/client';

export const ROUTE_SUBSCRIPTION_HOME = '/abbonamenti';
export const makePrestazioneRoute = (city: string, speciality: string) => `/prenota-visita/${speciality}/${city}`;
export const makePrestazioneRouteWithoutCity = (speciality: string) => `/prenota-visita/${speciality}`;
export const ROUTE_TERMS_CONDITIONS = '/termini-e-condizioni-del-servizio';
export const ELTY_SITE_URL = clientEnv.NEXT_PUBLIC_SITE_URL;
